export default {
  z50: "#F7FFF9",
  z100: "#EBFFEF",
  z200: "#CFFFDB",
  z300: "#A3F0B5",
  z400: "#5FD47A",
  z500: "#3AB757",
  z600: "#24963F",
  z700: "#267E3E",
  z800: "#0E5020",
  z900: "#0E401D",
  z_hover: "#8ADC82",
  rgb: {
    z100: "235,255,239",
    z200: "207,255,219",
    z300: "163,240,181",
    z400: "95,212,122",
    z500: "58,183,87",
    z600: "36,150,63",
    z700: "38,126,61",
    z800: "14,80,32",
    z900: "14,64,29"
  }
};
